import { SITE } from "@/mocks/site";

const quickChips = [
  "未官宣行程",
  "资源瓜",
  "新戏饼",
  "综艺邀约",
  "商务代言",
  "空降活动",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20editorial%20cinematic%20backdrop%20of%20a%20grand%20red%20velvet%20theater%20stage%20bathed%20in%20glowing%20crimson%20coral%20and%20amber%20spotlights%20with%20soft%20haze%20and%20cinematic%20light%20flares%20film%20cameras%20and%20microphone%20silhouettes%20near%20the%20frame%20edges%20deep%20charcoal%20shadows%20rich%20red%20orange%20and%20golden%20tones%20luxurious%20showbiz%20award%20atmosphere%20high%20end%20magazine%20aesthetic%20abstract%20and%20stylized%20no%20people%20faces%20no%20readable%20text&width=2000&height=1300&seq=radar-hero&orientation=landscape"
          alt="绯红舞台与琥珀灯光的娱乐情报封面背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/55 to-foreground-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-transparent to-primary-900/30"></div>
      </div>

      <div className="relative mx-auto flex min-h-[620px] w-full max-w-[1400px] flex-col justify-end px-4 pb-16 pt-28 md:min-h-[720px] md:px-6 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-400/40 bg-accent-500/15 px-3 py-1.5 text-xs font-semibold tracking-wide text-accent-200">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
            </span>
            圈内情报站 · 每日持续更新
          </span>

          <h2 className="mt-6 font-heading text-[34px] font-black leading-[1.12] tracking-tight text-background-50 md:text-[56px]">
            未官宣行程·资源瓜
            <span className="mt-1 block text-accent-300">新戏饼·综艺邀约，一网打尽</span>
          </h2>

          <p className="mt-5 max-w-2xl text-[15px] leading-relaxed text-background-200/90 md:text-base">
            想知道谁在谈新戏饼和综艺邀约？从商务代言到空降活动，
            {SITE.brand}把散落在圈内不同角落的资源线索整理成可追溯、分等级的爆料，
            帮你<strong className="font-semibold text-background-50">提前掌握明星的下一步动态</strong>。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#latest"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-all hover:bg-primary-400"
            >
              浏览今日爆瓜
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </a>
            <a
              href="#subscribe"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              订阅每日瓜报
              <i className="ri-mail-send-line text-base" aria-hidden="true"></i>
            </a>
          </div>

          <div className="mt-9 flex flex-wrap gap-2">
            {quickChips.map((c, i) => (
              <a
                key={c}
                href="#latest"
                className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-[13px] transition-colors ${
                  i % 2 === 0
                    ? "border-accent-400/30 bg-accent-500/10 text-accent-100 hover:bg-accent-500/25"
                    : "border-background-50/15 bg-background-50/5 text-background-100 hover:bg-background-50/15"
                }`}
              >
                #{c}
              </a>
            ))}
          </div>

          <div className="mt-10 grid max-w-xl grid-cols-3 divide-x divide-background-50/15 rounded-2xl border border-background-50/15 bg-foreground-950/30 backdrop-blur-sm">
            {[
              { num: "6 大", label: "追踪栏目" },
              { num: "每日", label: "多源刷新" },
              { num: "3 级", label: "可信分级" },
            ].map((s) => (
              <div key={s.label} className="px-3 py-4 text-center md:px-5">
                <p className="font-heading text-xl font-black text-accent-300 md:text-2xl">{s.num}</p>
                <p className="mt-1 text-xs text-background-200/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}